import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, PhoneIcon, NavigationIcon } from 'lucide-react';
export function LocationMap() {
  return <section className="py-20 px-4 bg-brand-dark text-white pt-[50px] pb-[50px]" data-id="element-120">
      <div className="max-w-6xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-122">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-123">
            Visit us
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold" data-id="element-124">
            Find our shop in St. Paul
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch" data-id="element-125">
          {/* Map */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="lg:col-span-3 rounded-2xl overflow-hidden shadow-2xl shadow-black/30 border border-gray-700 min-h-[320px]" data-id="element-126">
            <iframe title="Lancer Service location — 270 E 8th St, St Paul, MN 55101" src="https://www.google.com/maps?q=270+E+8th+St,+St+Paul,+MN+55101&output=embed" width="100%" height="100%" style={{
            border: 0,
            minHeight: '320px'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-127" />
          </motion.div>

          {/* Location details */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.25
        }} className="lg:col-span-2 flex flex-col justify-center gap-8" data-id="element-128">
            <div className="flex items-start gap-4" data-id="element-129">
              <div className="w-12 h-12 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-130">
                <MapPinIcon className="w-6 h-6 text-brand-accent" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <h3 className="font-heading uppercase tracking-wide font-bold text-lg mb-1" data-id="element-133">
                  Address
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-134">
                  270 E 8th Street
                  <br data-id="element-135" />
                  St Paul, MN 55101
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-136">
              <div className="w-12 h-12 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-137">
                <ClockIcon className="w-6 h-6 text-brand-accent" data-id="element-138" />
              </div>
              <div data-id="element-139">
                <h3 className="font-heading uppercase tracking-wide font-bold text-lg mb-1" data-id="element-140">
                  Hours
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-141">
                  Monday – Friday
                  <br data-id="element-142" />
                  7:00 am – 5:00 pm
                </p>
                <p className="text-gray-500 text-sm mt-1" data-id="element-143">
                  Closed Saturday & Sunday
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-144">
              <div className="w-12 h-12 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-145">
                <PhoneIcon className="w-6 h-6 text-brand-accent" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <h3 className="font-heading uppercase tracking-wide font-bold text-lg mb-1" data-id="element-148">
                  Phone
                </h3>
                <a href="tel:6512240267" className="text-gray-300 hover:text-brand-accent transition-colors text-lg font-medium" data-id="element-149">
                  (651) 224-0267
                </a>
              </div>
            </div>

            <a href="https://www.google.com/maps/dir/?api=1&destination=270+E+8th+St,+St+Paul,+MN+55101" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-md transition-colors shadow-lg shadow-brand-accent/20 mt-2" data-id="element-150">
              <NavigationIcon className="w-5 h-5" data-id="element-151" />
              Get Directions
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}